import contains from "ramda/src/contains"
import pick from "ramda/src/pick"
import difference from "ramda/src/difference"
import keys from "ramda/src/keys"
import values from "ramda/src/values"
import mergeWith from "ramda/src/mergeWith"
import join from "ramda/src/join"
import { normalizeTargetSystem } from "services/utils/action"
import { CONFIG } from "./constants"

export function normalizeDefaultOrder({ customer }, operation, product) {
  return {
    typeService: operation,
    documentNumber: customer.documentNumber,
    destinationSystem: normalizeTargetSystem(product),
    broadband: {
      circuit: product.circuit,
      agreement: product.agreementId
    }
  }
}

export function normalizeOrder({ customer }, operation, product) {
  const order = normalizeDefaultOrder(customer, operation, product)

  if (operation === CONFIG) return order

  return {
    ...order,
    settings: {
      parameters: [
        {
          name: "Reboot Modem",
          value: ""
        }
      ]
    }
  }
}

export function normalizeServiceRequest({ customer, product }) {
  return {
    cpfCnpj: customer.documentNumber,
    customerId: customer.customerId,
    name: customer.name,
    email: customer.email,
    assetId: product.agreementId,
    telCtbc: customer.smsPhoneNumber,
    customizations: [
      {
        item: "resetModem",
        value: "true"
      }
    ]
  }
}

// {
//    "legalName":"",
//    "phoneNumber":"",
//    "contactName":"",
//    "contactPhone":"",
//    "protocol":"",
//    "serviceId":"",
//    "reason":"Teste abertura de chamados 3",
//    "timeSlot":"",
//    "description":"Teste abertura",
//    "odinProduct":
// }

function getDescriptionPairs({ labels, data }, fields) {
  const diffProperties = difference(keys(data), fields)
  const diffData = pick(diffProperties, data)
  const diffLabels = pick(diffProperties, labels)
  return [diffLabels, diffData]
}

function formatDescriptionPairs([labels, data]) {
  return values(mergeWith((a, b) => `${a}: ${b}`, labels, data))
}

function getDescriptionPair({ labels, data }) {
  const getter = pick(["description"])

  const [description] = values(
    formatDescriptionPairs([getter(labels), getter(data)])
  )

  return description
}

function getAdditionalDescriptionPairs(checklist, fields) {
  const pairs = getDescriptionPairs(checklist, fields)
  const fmtPairs = formatDescriptionPairs(pairs)

  return fmtPairs
}

function addDescriptionProperties(checklist, fields) {
  const description = getDescriptionPair(checklist)
  const additionals = getAdditionalDescriptionPairs(checklist, fields)

  return join(", ", [description, ...values(additionals)])
}

export function normalizeIncidentOrder(meta, product, checklist) {
  const data = {
    ...checklist.data,
    description: addDescriptionProperties(checklist, meta.fields)
  }

  return {
    product,
    ...pick(meta.fields, data)
  }
}

export function normalizeOdinIncidentOrder(meta, product, checklist, customer) {
  const data = {
    contractNumber: product.serviceId,
    businessLine: "DATA CENTER",
    requestType: "INCIDENTE",
    customerId: customer.customerId,
    documentNumber: customer.documentNumber,
    legalName: customer.name,
    phoneNumber: customer.tamPhoneNumber,
    contactName: checklist.data.contactName,
    contactphone: checklist.data.contactPhone,
    serviceId: product.serviceId,
    reason: checklist.data.description,
    timeSlot: checklist.data.timeSlot,
    user: "PORTAL_CLIENTES",
    systemProduct: "ODIN",
    description: addDescriptionProperties(checklist, meta.fields),
    origination: ""
  }

  return { ...data }
}

export const CREATE_COMMON_INCIDENT_ORDER_PAYLOAD = {
  fields: [
    "contactName",
    // 'contactPhone',
    "description",
    // 'reason',
    "timeSlot"
  ]
}

export const CREATE_ODIN_SERVICE_ORDER_PAYLOAD = {
  fields: ["contactName", "contactPhone", "description"]
}

const checkDemandByStatus = (status, requestStatus) => {
  let addDemand = false
  if (status !== "PROGRESS" && requestStatus === "DEMANDA CONCLUÍDA") {
    addDemand = true
  }

  if (
    status === "PROGRESS" &&
    requestStatus !== "DEMANDA CONCLUÍDA" &&
    !contains(requestStatus, ["DEMANDA CANCELADA", "NOT SUPPORTED"])
  ) {
    addDemand = true
  }

  return addDemand
}

export function getRepairByStatus(demands, status) {
  if (!demands) return []
  let repairByStatus = []

  repairByStatus = demands.filter((demand) => {
    const requestStatus = demand.requestStatus.toUpperCase()
    return checkDemandByStatus(status, requestStatus)
  })

  return cleanDemands(repairByStatus)
}

export function cleanDemands(demands) {
  return demands && demands.filter((demand) => demand.protocolNumber !== "")
}



// WEBPACK FOOTER //
// ./src/services/state/repair/helpers.js